import accessToken from "../../helpers/accessToken";
import router from "../../router/index";
import Mixins from "../../mixins/GlobalMixins";
import API_URL from "../../helpers/apiUrls";

const state = {
  userData: null,
  showReplyDialog:false
};

const mutations = {
  SET_USER_DATA: (state, value) => {
    console.log('state',state,value);
    state.userData=value;
  },
  SET_TOGGLE_REPLY_DIALOG: (state, value) => {
    console.log('state',state,value);
    state.showReplyDialog=!state.showReplyDialog;
  },
};

const actions = {
  setOrderSuccessDetails({ commit }, data) {
    commit("SET_USER_DATA", data);
  },

  setShowReplyToggle({ commit }, data) {
    commit("SET_TOGGLE_REPLY_DIALOG", data);
  },

  // REFRESH TOKEN WHEN THE TOKEN IS EXPIRED AND RE-CALL THE API WHICH IS QUEUED.

  // IMAGE UPLOAD
};

const getters = {
  GET_USER_DATA: (state) => state.userData,
  GET_TOGGLE_STATE: (state) => state.showReplyDialog,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
